import { TextVariants } from '@lichtblick/theme';
import { ApprovalState } from '@lichtblick/types';

import { ChipContainer, IdContainer } from './SearchCard.styles';

import { Card } from '../../Card';
import { Chip } from '../../Chip';
import { Text } from '../../Text';

export type SearchCardProps = {
  data: {
    clientAddress: string;
    clientName: string;
    id: string;
    orderName: string;
    status: ApprovalState;
  };
};

export const SearchCard = ({ data: { clientAddress, clientName, id, orderName, status } }: SearchCardProps) => (
  <Card isBorderless={false}>
    <Text $variant={TextVariants.title.l}>{orderName}</Text>
    <IdContainer>
      <Text $variant={TextVariants.body.m}>ID:</Text>
      <Text $variant={TextVariants.title.m}> {id}</Text>
    </IdContainer>
    <Text $variant={TextVariants.body.m}>{clientName}</Text>
    <Text $variant={TextVariants.body.xs}>{clientAddress}</Text>
    <ChipContainer>
      <Chip size="small" text="In Progress" variant={status} />
    </ChipContainer>
  </Card>
);
